import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9450af10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-banks" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Banks", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_9 = { class: "checkbox-button ml-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_11 = { class: "accounting-software" }
const _hoisted_12 = { class: "ls-table" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { "data-label": "Name" }
const _hoisted_20 = { "data-label": "Status" }
const _hoisted_21 = { "data-label": "Actions" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditBankModal = _resolveComponent("AddEditBankModal")
  const _component_BankAuditTrailModal = _resolveComponent("BankAuditTrailModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
              placeholder: "Search bank name"
            }, null, 512), [
              [_vModelText, _ctx.searchKeyword]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveOnly) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showActiveOnly]
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary mr-2",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.addBank()))
        }, "Add new bank")
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("div", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_14)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_16)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredBankList.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_18)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredBankList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filteredBankList, (a) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_19, _toDisplayString(a.name), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(a.status.name), 1),
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml mr-2",
                            onClick: $event => (_ctx.editBank(a))
                          }, "Edit", 8, _hoisted_22),
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.viewBankAuditTrail(a))
                          }, "Audit Trail", 8, _hoisted_23)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary sml mt-2",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.addBank()))
      }, "Add new bank")
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditBankModal, {
          key: 0,
          bank: _ctx.selectedBank,
          onCloseAddEditBankModal: _cache[4] || (_cache[4] = $event => {_ctx.showAddEditModal = false;})
        }, null, 8, ["bank"]))
      : _createCommentVNode("", true),
    (_ctx.showAuditTrailModal)
      ? (_openBlock(), _createBlock(_component_BankAuditTrailModal, {
          key: 1,
          bank: _ctx.selectedBank,
          onCloseAuditTrailModal: _cache[5] || (_cache[5] = $event => {_ctx.showAuditTrailModal = false;})
        }, null, 8, ["bank"]))
      : _createCommentVNode("", true)
  ]))
}